import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RestDataService {

  constructor(private http: HttpClient) { }

  get<T>(fromUrl:string):Observable<T>{
    return this.http.get<T>(fromUrl).pipe(
          catchError(this.handleError<T>('get'))
        )
  }


  put<T>(toUrl:string,data:T):Observable<T>{
    return this.http.put<T>(toUrl,data).pipe(
          catchError(this.handleError<T>('get'))
        )
  }

  post<T>(toUrl:string,data:T):Observable<T>{
    return this.http.post<T>(toUrl,data).pipe(
          catchError(this.handleError<T>('get'))
        )
  }

  private handleError<T> (operation = 'operation') {
    return (error: any): Observable<T> => {
      console.error(error);
      throw error;
    };
  }

  addIdToURL(id:string,url:string){
    return url.replace('<id>',id);
  }


}
